
import React from 'react'

export default function UpdateRecordButton (props) {


    return "UpdateButton";
}
